import { IncidentCategory } from '../enum';
export const getAllIncidentCategories = () => {
    return [
        { id: IncidentCategory.INCIDENT, name: 'Incident' },
        { id: IncidentCategory.EXERCISE, name: 'Exercise' },
        { id: IncidentCategory.TRAINING, name: 'Training' },
    ];
};
